module.exports = __webpack_public_path__ + "static/img/Ya_Ning_Yen.png";